import { SearchFilterField } from '@/ui/composites/filters/SearchFilterField';
import { Box } from '@/ui/primitives';
import {
  buildMetricsToolbarSearchContainerSx,
  buildMetricsToolbarSearchFieldSx,
} from './MetricsToolbarSearchControl.styles';
import type { ReactElement, RefObject } from 'react';

type MetricsToolbarSearchControlProps = {
  toolbarExpandedSearchWidth: number;
  toolbarControlSize: number;
  toolbarSearchWidthPx: string;
  searchValue: string;
  searchAriaLabel: string;
  setSearchValue: (value: string) => void;
  searchInputRef: RefObject<HTMLInputElement | null>;
  handleSearchBlur: () => void;
  handleSearchKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

export const MetricsToolbarSearchControl = ({
  toolbarExpandedSearchWidth,
  toolbarControlSize,
  toolbarSearchWidthPx,
  searchValue,
  searchAriaLabel,
  setSearchValue,
  searchInputRef,
  handleSearchBlur,
  handleSearchKeyDown,
}: MetricsToolbarSearchControlProps): ReactElement => {
  const toolbarFieldBackgroundColor = 'var(--surface-inset)';

  return (
    <Box
      sx={buildMetricsToolbarSearchContainerSx({
        toolbarControlSize,
        toolbarExpandedSearchWidth,
      })}
    >
      <SearchFilterField
        value={searchValue}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        inputAriaLabel={searchAriaLabel}
        inputBackgroundColor={toolbarFieldBackgroundColor}
        controlHeight={toolbarControlSize}
        compact
        leadingSearchAdornment={false}
        trailingSearchAdornment
        filledClearIcon={false}
        sx={buildMetricsToolbarSearchFieldSx({
          toolbarControlSize,
          toolbarSearchWidthPx,
        })}
        slotProps={{
          htmlInput: {
            ref: (instance: HTMLInputElement | null) => {
              searchInputRef.current = instance;
            },
            onBlur: handleSearchBlur,
            onKeyDown: handleSearchKeyDown,
          },
        }}
      />
    </Box>
  );
};
